<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h1>404</h1>
        <p>Page not found.</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'not-found'
};
</script>
